import FormElementMixin from '../mixins/FormElementMixin.js';

Vue.asyncComponent('ak-checkboxes', {
    mixins: [FormElementMixin],
    props: {
        selectOptions: {
            type: Array,
            required: true
        },
        columns: {
            type: Number|String,
            required: false
        },
        selectOptionsDisabled: {
            type: Array|Object,
            default: () => {
                return [];
            }
        }
    },
    data() {
        return {
            selected: this.value ? [ ...this.value ] : []
        }
    },
    computed: {
        currentSelectOptionsDisabled() {
            // Make sure we are working with an array.
            // We do this because if we send an array with numbers that skip a step, js turns it into an object.
            return typeof this.selectOptionsDisabled === 'object'
                    ? Object.values(this.selectOptionsDisabled)
                    : this.selectOptionsDisabled;
        }
    },
    watch: {
        // Watch for external changes to the 'value' prop
        value: {
            handler(newValue, oldValue) {
                if ( ! this.$deepEqual(newValue, oldValue)) {
                    this.selected = newValue ? [ ...newValue ] : [];
                }
            },
            deep: true
        },
        selected() {
            this.currentValue = this.selected;
        }
    },
    methods: {
        isDisabled(option) {
            return this.currentSelectOptionsDisabled.includes(option.value)
        }
    }
}, 'form/controls/ak-checkboxes.html');